module.exports = __webpack_public_path__ + "img/67.536d901c.jpg";